import { NgModule, inject } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotFoundComponent } from './shared/not-found/not-found.component';
import { CanActivate } from './classes/can-activate';
import { environment } from 'src/environments/environment.dev';

const routes: Routes = [
  // Here You Add Your Lazy Loading Modules
  // e.g
  {
    path: 'home',
    redirectTo: '',
    pathMatch: 'full',
  },
  {
    path: '',
    title: 'ایرانی اکسپرت - آموزش فارکس| ترید فارکس| ربات خودکار فارکس',
    loadChildren: () =>
      import('./routes/Home/modules/home.module').then((m) => m.HomeModule),
  },

  {
    canActivate: [() => inject(CanActivate).canActivate()],
    path: 'checkout',
    loadChildren: () =>
      import('./routes/Checkout/checkout.module').then((m) => m.CheckoutModule),
  },
  {
    path: 'brokers',
    title: 'بررسی و مقایسه بروکرهای فارکس',
    loadChildren: () =>
      import('./routes/Brokers/module/broker.module').then(
        (m) => m.BrokerModule
      ),
  },
  {
    path: 'articles',
    title: 'آموزش جامع فارکس | مجله بازارهای مالی',
    loadChildren: () =>
      import('./routes/Blog/module/blog.module').then((m) => m.BlogModule),
  },
  {
    path: 'shop',
    title: 'ربات‌های ایرانی اکسپرت | بهترین ربات فارکس | بهترین ربات پراپ | خرید اکسپرت تضمینی',
    loadChildren: () =>
      import('./routes/Shop/module/shop.module').then((m) => m.ShopModule),
  },
  {
    path: 'money-management',
    title: 'تکنیک های مدیریت سرمایه چیست؟اصول مدیریت ریسک و سرمایه گذاری',
    loadChildren: () =>
      import('./routes/Money-Management/module/money-m.module').then(
        (m) => m.MoneymModule
      ),
  },
  {
    path: 'about-us',
    title: 'چرا ما؟ (رضایت تریدرها+ تماس با ما+ درباره ما+ مشاوره رایگان) ',
    loadChildren: () =>
      import('./routes/About-us/module/about-us.module').then(
        (m) => m.AboutUsModule
      ),
  },
  {
    path: 'expert-advisor',
    title: 'موفقیت‌های ربات‌های معامله‌گر در سال 2026 چیست؟ نحوه عملکرد + دانلود',
    loadChildren: () =>
      import('./routes/Robot-trader/module/robot-trader.module').then(
        (m) => m.RobotTraderModule
      ),
  },
  {
    path: 'copy-trade',
    title:
      ' بهترین کپی تریدینگ در سال 2026 | سود تضمینی',
    loadChildren: () =>
      import('./routes/Copy-trade/module/copy-trade.module').then(
        (m) => m.CopyTradeModule
      ),
  },
  {
    path: 'contact-us',
    title:
    'تماس با ما | تماس با ایرانی اکسپرت',
    loadChildren: () =>
      import('./routes/Contact-us/module/contact-us.module').then(
        (m) => m.ContactUsModule
      ),
  },
  {
    path: 'prop-trading',
    title: 'بررسی شرکت های معتبر پراپ تریدینگ 2026 و مقایسه آن‌ها',
    loadChildren: () =>
      import('./routes/Prop/madules/prop-trading.module').then(
        (m) => m.PropTradingModule
      ),
  },
  
  {
    path: 'economic-calendar',
    title:
      'تقویم اقتصادی فارکس  امروز | فارکس فکتوری فارسی | آپدیت لحظه‌ای',

    loadChildren: () =>
      import('./routes/calendar/module/calendar.module').then(
        (m) => m.CalendarModule
      ),
  },
  {
    path: 'college',
    title:
    'آموزش جامع ترید | فارکس +10 کلیپ آموزشی رایگان ✔️ یوتیوب و آپارات',

    loadChildren: () =>
      import('./routes/College/module/college.module').then(
        (m) => m.CollegeModule
      ),
  },
  {
    path: 'propfirms',
    title:
    'بررسی و مقایسه شرکت‌های پراپ | مقایسه پراپ‌فرم‌ها',

    loadChildren: () =>
      import('./routes/Propfirms/module/propfirm.module').then(
        (m) => m.PropFirmModule
      ),
  },
  {
    path: '**',
    title: 'ایرانی اکسپرت ',
    component: NotFoundComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabledBlocking',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
